export const jobStates: KeyValue[] = [
  { key: 'Pending', value: 0 },
  { key: 'Running', value: 1 },
  { key: 'Completed', value: 2 },
  { key: 'Failed', value: 3 }
];

export const triggerTypes: KeyValue[] = [
  { key: 'Scheduled', value: 0 },
  { key: 'Manual', value: 1 },
  { key: 'BlobTrigger', value: 2 },
  { key: 'DistributedLockRelease', value: 3 }
];

export const logLevels: KeyValue[] = [
  { key: 'Trace', value: 0 },
  { key: 'Debug', value: 1 },
  { key: 'Information', value: 2 },
  { key: 'Warning', value: 3 },
  { key: 'Error', value: 4 },
  { key: 'Critical', value: 5 },
  { key: 'None', value: 6 }
];

export class KeyValue {
  key: string;
  value: number;
}
